export default __webpack_public_path__ + "static/media/pag-bootstrap.805ea7e6.png";